import { Callout } from "../components/Callout.js";

export const meta = {
  title: "送信上限と請求",
  updatedAt: "2026-07-23",
};

export function Content() {
  return (
    <>
      <p>
        プランごとに月間の送信件数上限が設定されています。
        このページでは上限到達時の挙動と請求の仕組みを説明します。
      </p>

      <h2>送信件数のカウント方法</h2>
      <ul>
        <li>1 つの書類作成（送信モード問わず）= 1 件</li>
        <li>同じ書類への共有先（CC）追加はカウント対象外</li>
        <li>下書きキャンセル / 取り消しでも 1 件はカウント済みのまま</li>
        <li>カウントは請求期間（お申し込み日を起点とした 1 か月）ごとにリセット。例: 10 月 16 日にお申し込みの場合は毎月 16 日</li>
        <li>請求期間と次のリセット日は「プラン・請求」タブに表示されます</li>
      </ul>

      <h2>上限到達時の挙動</h2>
      <ul>
        <li><strong>上限に達すると送信できなくなります</strong>（送信時にエラーが表示されます）</li>
        <li>70% / 90% / 100% 到達時に自動でメール + ベル通知</li>
        <li>上限を大幅に超えた場合、上位プランへの自動移行はしません（手動でアップグレードを推奨）</li>
      </ul>

      <Callout type="info" title="送信件数のリアルタイム確認">
        「プラン・請求」タブの上部に、今回の請求期間の使用件数と上限が常時表示されます。
      </Callout>

      <h2>通知メールの内容</h2>
      <ul>
        <li>件名: 「【◯% 到達】Sign Extension for クラウドサイン 月間送信使用量」</li>
        <li>本文: 当月の使用件数、残り件数、推奨プラン</li>
        <li>送信先: テナント内のオーナーおよび管理者権限のユーザー</li>
      </ul>

      <Callout type="warning" title="通知の重複防止">
        同じしきい値（例: 70%）の通知は、その月内では 1 回のみ送信されます。
        翌月リセット時に再度通知対象に戻ります。
      </Callout>

      <h2>プラン別上限の早見表</h2>
      <table style={{ width: "100%", borderCollapse: "collapse", margin: "12px 0", fontSize: 13 }}>
        <thead>
          <tr style={{ background: "#faf9f7" }}>
            <th style={th()}>プラン</th>
            <th style={th()}>月間上限</th>
            <th style={th()}>70%</th>
            <th style={th()}>90%</th>
            <th style={th()}>100%</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style={td()}>Starter</td><td style={td()}>30</td><td style={td()}>21</td><td style={td()}>27</td><td style={td()}>30</td></tr>
          <tr><td style={td()}>Professional</td><td style={td()}>100</td><td style={td()}>70</td><td style={td()}>90</td><td style={td()}>100</td></tr>
          <tr><td style={td()}>Enterprise</td><td style={td()}>無制限</td><td style={td()}>—</td><td style={td()}>—</td><td style={td()}>—</td></tr>
        </tbody>
      </table>

      <h2>プラン変更による影響</h2>
      <p>
        月の途中でプラン変更した場合:
      </p>
      <ul>
        <li>
          <strong>アップグレード</strong>: 即時、新プランの上限が適用される。
          既に使った件数は引き続きカウント
        </li>
        <li>
          <strong>ダウングレード</strong>: 即時、新プランの上限が適用される。
          既に新プラン上限を超えていれば、その月は上限超過状態
        </li>
        <li>
          <strong>解約</strong>: 契約期間終了後は、再度お申し込みいただくまで書類の送信ができません
        </li>
      </ul>

      <h2>請求のタイミング</h2>
      <ul>
        <li>月額制（前払い）</li>
        <li>お申し込みいただいた日に初回課金（無料トライアル中のお申し込みも同様）</li>
        <li>以降は申し込み日と同じ日に毎月課金</li>
        <li>Stripe からの請求書メールが自動送付</li>
      </ul>

      <Callout type="tip" title="月次レポート">
        プラン・請求タブの「請求・明細の管理」セクションの「請求履歴・領収書を確認」から、
        過去の請求書 PDF をダウンロードできます。経費精算や月次レポートにご活用ください。
      </Callout>
    </>
  );
}

function th() {
  return { textAlign: "left" as const, padding: "8px 12px", borderBottom: "1px solid #d0cfc9" };
}
function td() {
  return { padding: "8px 12px", borderBottom: "1px solid #f0efeb" };
}
